import * as types from './actionTypes';

const initialState = {
	filterOpen: false,
	inputFocus: false,
	pristine: true
};

export default function reducer(state = initialState, action = {}) {
	switch(action.type) {
		case types.INITIALIZE_SEARCH: {
			return {
				...state,
				filterOpen: false,
				inputFocus: false,
				pristine: true
			};
		}
		case types.TOGGLE_FILTER_DISPLAY: {
			return {
				...state,
				filterOpen: !state.filterOpen
			};
		}
		case types.SEARCH_INPUT_BLUR: {
			return {
				...state,
				inputFocus: false
			};
		}
		case types.SEARCH_INPUT_FOCUS: {
			return {
				...state,
				inputFocus: true
			};
		}
		case types.SEARCH_INPUT_DIRTY: {
			return {
				...state,
				pristine: false
			};
		}
		default:
			return state;
	}
}


/** WEBPACK FOOTER **
 ** ./src/modules/search/reducer.js
 **/